<!-- 落地页管理 -->
<template>
  <div>
    <div :style="{ width: table_scroll_width + 'px' }">
      <div
        :style="{ width: body_width - 60 + 'px' }"
        style="position: sticky; left: 30px; z-index: 5"
      >
        <!-- 标题 -->
        <div class="page-title">落地页管理</div>

        <!-- 筛选条件 -->
        <div style="margin: 10px 0 0">
          <div style="display: flex; align-items: center; flex-wrap: wrap">
            <div class="screen-box">
              <div class="screen-label">ID</div>
              <a-input
                v-model="r_id"
                allowClear
                placeholder="请输入"
                style="width: 200px"
              />
            </div>

            <div class="screen-box">
              <div class="screen-label">标题</div>
              <a-input
                v-model="r_title"
                allowClear
                placeholder="请输入"
                style="width: 200px"
              />
            </div>

            <div
              v-if="role_control.includes(1) || role_control.includes(3)"
              class="screen-box"
            >
              <div class="screen-label">投手</div>
              <a-select
                show-search
                style="min-width: 160px"
                placeholder="请选择投手"
                @change="handleChangeA"
                :filter-option="filterOption"
                :getPopupContainer="getsPopupContainer"
                allowClear
              >
                <a-select-option
                  v-for="(item, index) in filterData.op_id.list"
                  :key="index"
                  :value="item.key"
                >
                  {{ item.value }}
                </a-select-option>
              </a-select>
            </div>

            <div class="screen-box">
              <div class="screen-label">书城渠道</div>
              <a-select
                show-search
                style="min-width: 180px"
                placeholder="请选择书城"
                @change="handleChangeF"
                :filter-option="filterOption"
                :getPopupContainer="getsPopupContainer"
                allowClear
              >
                <a-select-option
                  v-for="(item, index) in filterData.channel_id.list"
                  :key="index"
                  :value="item.key"
                >
                  {{ item.value }}
                </a-select-option>
              </a-select>
            </div>

            <div v-if="filterData.hasOwnProperty('gzh_id')" class="screen-box">
              <div class="screen-label">公众号</div>

              <moreSelect
                ref="getGzhSelect"
                :placeholder="'请选择公众号'"
                :select_mode="''"
                @handleChangeSelect="handleChangeG"
              ></moreSelect>
            </div>

            <div class="screen-box">
              <div class="screen-label">跳转方式</div>
              <a-select
                style="min-width: 240px"
                placeholder="请选择跳转方式"
                @change="handleChangeH"
                :getPopupContainer="getsPopupContainer"
                allowClear
              >
                <a-select-option
                  v-for="(value, key) in JumpTypeData"
                  :key="key"
                  :value="key"
                >
                  {{ value }}
                </a-select-option>
              </a-select>
            </div>

            <div class="screen-box">
              <div class="screen-label">投放平台</div>
              <a-select
                style="min-width: 160px"
                placeholder="请选择投放平台"
                @change="handleChangeI"
                :getPopupContainer="getsPopupContainer"
                allowClear
              >
                <a-select-option
                  v-for="(value, key) in PlatformData"
                  :key="key"
                  :value="key"
                >
                  {{ value }}
                </a-select-option>
              </a-select>
            </div>

            <div class="screen-box">
              <div class="screen-label">是否打开投放</div>
              <a-select
                style="min-width: 200px"
                placeholder="请选择是否打开投放"
                @change="handleChangeJ"
                :getPopupContainer="getsPopupContainer"
                allowClear
              >
                <a-select-option value="0"> 否 </a-select-option>
                <a-select-option value="1"> 是 </a-select-option>
              </a-select>
            </div>

            <a-button
              @click="searchButton('button')"
              :loading="search_button_loading"
              type="primary"
              icon="search"
              class="screen-box"
              >搜索</a-button
            >

            <div class="screen-box">
              <a-dropdown-button @click="handleButtonClick">
                批量操作
                <a-menu slot="overlay" @click="handleMenuClick">
                  <a-menu-item key="1">
                    <a-icon type="align-right" />批量设置巨量付费2（已选{{
                      selectedData.length
                    }}项）</a-menu-item
                  >
                  <a-menu-item key="2">
                    <a-icon type="align-right" />批量删除（已选{{
                      selectedData.length
                    }}项）</a-menu-item
                  >
                </a-menu>
              </a-dropdown-button>
            </div>

            <a-button
              @click="addShowDrawer(1)"
              type="primary"
              icon="plus"
              class="screen-box"
              style="background-color: #67c23a; border-color: #67c23a"
              >新增落地页</a-button
            >

            <!-- <a-button @click="addShowDrawer(2)" type="primary" icon="plus" class="screen-box"  style="background-color: #67c23a;border-color: #67c23a;">新增360落地页</a-button> -->
          </div>
        </div>
      </div>
    </div>

    <div style="">
      <!-- 表头 -->
      <div class="table-th" :style="{ width: table_scroll_width + 'px' }">
        <div
          class="table-th-cell-sticky"
          style="display: flex; align-items: center"
        >
          <div class="table-th-cell" :style="{ width: 40 + 'px' }">
            <a-checkbox
              :indeterminate="indeterminate"
              :checked="checkAll"
              @change="onCheckAllChange"
            ></a-checkbox>
          </div>
          <div
            class="table-th-cell"
            :style="{ width: rableTitle[0].width + 'px' }"
          >
            {{ rableTitle[0].title }}
          </div>
          <div
            class="table-th-cell"
            :style="{ width: rableTitle[1].width + 'px' }"
          >
            {{ rableTitle[1].title }}
          </div>
        </div>
        <div v-for="(item, index) in rableTitle" :key="index">
          <div
            class="table-th-cell"
            v-if="index > 1"
            :style="{ width: item.width + 'px' }"
          >
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- 表格内容 -->
      <div>
        <!-- <div  :style="{'height':table_body_height + 'px', 'width':(rableTitle[0].width + rableTitle[1].width) + 'px'}" style="background-color: #fff;position: absolute;"></div> -->
        <div
          ref="tdHeight"
          v-for="(item, index) in tableShowData"
          :key="index"
          class="table-td"
          :style="{ width: table_scroll_width + 'px' }"
        >
          <div
            class="table-td-cell-sticky"
            style="display: flex; align-items: center"
            :style="{ height: item.height + 'px' }"
          >
            <!-- 选择 -->
            <div class="table-td-cell" :style="{ width: 40 + 'px' }">
              <a-checkbox
                :checked="item.checked"
                @change="onChangeCheckbox($event, index)"
              ></a-checkbox>
            </div>
            <!-- ID -->
            <div
              class="table-td-cell"
              :style="{ width: rableTitle[0].width + 'px' }"
            >
              {{ item.id }}
            </div>
            <!-- 落地页名称 -->
            <div
              class="table-td-cell"
              :style="{ width: rableTitle[1].width + 'px' }"
            >
              <div
                v-if="!item.title_input_control"
                @click="ldTitleClick(item)"
                style="color: #62a8ea; cursor: pointer"
              >
                {{ item.title }}
              </div>
              <a-input
                v-else
                @blur="LdTitleChange($event, item, index)"
                ref="title_input"
                :value="item.title"
                placeholder="Basic usage"
              />
            </div>
          </div>
          <!-- 落地页链接 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[2].width + 'px' }"
          >
            <div>
              <span>投放地址：</span>
              <a-icon
                @click="thDzCopy(item)"
                type="copy"
                style="font-size: 13px; cursor: pointer"
              />
            </div>
            <a-tooltip v-if="item.put_platform == '快手'" placement="top">
              <template slot="title">
                <div v-if="item.put_platform == '快手'">
                  {{
                    `${item.put_url}?ip=__IP__&ua=__UA__&account_id=__ACCOUNTID__&aid=__AID__&did=__DID__&cid=__CID__&clk_time=__TS__&os=__OS__&model=__MODEL__&imei_md5=__IMEI2__&idfa=__IDFA__&android_id_md5=__ANDROIDID2__&ipv6=__IPV6__&callback=__CALLBACK__`
                  }}
                </div>
              </template>
              <div
                style="
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
              >
                {{
                  `${item.put_url}?ip=__IP__&ua=__UA__&account_id=__ACCOUNTID__&aid=__AID__& ... 鼠标悬浮查看全部`
                }}
              </div>
            </a-tooltip>
            <div v-else>{{ item.put_url }}</div>

            <div
              v-if="item.put_platform == '头条' || item.put_platform == '百度'"
              style="margin-top: 7px"
            >
              <span>联调地址：</span>
              <a-icon
                @click="thLtCopy(item)"
                type="copy"
                style="font-size: 13px; cursor: pointer"
              />
            </div>
            <div v-if="item.put_platform == '头条'">
              {{ `${item.put_url}?liantiao=1` }}
            </div>
            <div v-else-if="item.put_platform == '百度'">
              {{ `${item.put_url}?bd_vid={bd_vid}&liantiao=1` }}
            </div>
          </div>
          <!-- 公众号 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[3].width + 'px' }"
          >
            {{ item.gzh_name }}
          </div>
          <!-- 顶部图片 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[4].width + 'px' }"
          >
            <img
              v-if="item.top_image"
              @click="tdShowImg(item)"
              :src="item.top_image"
              style="
                width: 100%;
                max-height: 120px;
                object-fit: contain;
                cursor: pointer;
              "
              alt=""
            />
          </div>
          <!-- 跳转方式 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[5].width + 'px' }"
          >
            {{ item.jump_type }}
          </div>
          <!-- 关联小程序 -->
          <div
            class="table-td-cell"
            style="display: flex; flex-wrap: wrap"
            :style="{ width: rableTitle[6].width + 'px' }"
          >
            <div v-if="item.gzh_app_rel.length > 3">
              <div
                v-for="(item_x, index_x) in item.show_gzh_app.slice(0, 3)"
                :key="index_x"
                @click="jumpHandle(item_x)"
                :class="{
                  'xcx-cell': item_x.is_using == 1,
                  'xcx-cell-false': item_x.is_using == 0,
                }"
                class="xcx-cell"
              >
                {{ item_x.name }}
              </div>
              <a-popover placement="top">
                <template slot="content">
                  <div style="width: 500px; display: flex; flex-wrap: wrap">
                    <div
                      v-for="(item_x, index_x) in item.show_gzh_app"
                      :key="index_x"
                      @click="jumpHandle(item_x)"
                      :class="{
                        'xcx-cell': item_x.is_using == 1,
                        'xcx-cell-false': item_x.is_using == 0,
                      }"
                      class="xcx-cell"
                    >
                      {{ item_x.name }}
                    </div>
                  </div>
                </template>
                <div>
                  <div
                    style="
                      font-size: 13px;
                      color: #62a8ea;
                      cursor: pointer;
                      margin-top: 10px;
                    "
                  >
                    查看全部
                  </div>
                </div>
              </a-popover>
            </div>

            <div v-else>
              <div
                v-for="(item_x, index_x) in item.show_gzh_app"
                :key="index_x"
                @click="jumpHandle(item_x)"
                :class="{
                  'xcx-cell': item_x.is_using == 1,
                  'xcx-cell-false': item_x.is_using == 0,
                }"
                class="xcx-cell"
              >
                {{ item_x.name }}
              </div>
            </div>
          </div>
          <!-- 投放平台 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[7].width + 'px' }"
          >
            {{ item.put_platform }}
          </div>
          <!-- 是否打开投放 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[8].width + 'px' }"
          >
            <a-switch
              @change="openPut($event, index)"
              :loading="item.open_put_loading"
              :checked="!!item.open_put"
              checked-children="打开"
              un-checked-children="关闭"
            />
          </div>
          <!-- 回传比例 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[9].width + 'px' }"
            style="color: #62a8ea; cursor: pointer"
          >
            <div @click="editTd(item, 1)" v-if="item.put_platform != '微博'">
              {{ item.report_per }}
            </div>
          </div>
          <!-- 操作 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[10].width + 'px' }"
            style="display: flex; flex-wrap: wrap"
          >
            <div @click="editLand(item)" class="td-cz" style="color: #e6a23c">
              编辑
            </div>
            <div @click="thCopy(item)" class="td-cz" style="color: #62a8ea">
              复制
            </div>
            <div @click="thDel(item)" class="td-cz" style="color: red">
              删除
            </div>
            <div
              v-if="item.put_platform != '微博'"
              @click="returnRatio(item, 1)"
              class="td-cz"
              style="color: #62a8ea"
            >
              回传比例修改记录
            </div>
            <div
              v-if="item.put_platform != '微博'"
              @click="returnRatio(item, 2)"
              class="td-cz"
              style="color: #62a8ea"
            >
              添加回传比例任务
            </div>
            <!-- <a-button style="background-color: #e6a23c;border-color: #e6a23c;margin-right: 10px;" size='small' type="primary">编辑</a-button>
					<a-button @click="thCopy(item)" type="primary" size='small' style="margin-right: 10px;">复制</a-button>
					<a-button @click="thDel(item)" type="danger" size='small'>删除</a-button>
					<a-button @click="returnRatio(item,1)" type="primary" size='small' style="margin-right: 10px;margin-top: 10px;">回传比例修改记录</a-button>
					<a-button @click="returnRatio(item,2)" type="primary" size='small' style="margin-right: 10px;margin-top: 10px;">添加回传比例任务</a-button> -->
          </div>
          <!-- 创建人 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[11].width + 'px' }"
          >
            {{ item.op_name }}
          </div>
          <!-- 创建时间 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[12].width + 'px' }"
          >
            {{ item.created_at }}
          </div>
          <!-- 跳转落地页 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[13].width + 'px' }"
          >
            {{ item.redirect_to }}
          </div>
          <!-- 备注 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[14].width + 'px' }"
          >
            {{ item.memo }}
          </div>
        </div>
      </div>

      <!-- 表格内容为空时显示 -->
      <tableNull
        :tableShowData="tableShowData"
        :table_null_width="table_null_width"
      ></tableNull>
    </div>

    <pagingCompont
      :table_scroll_width="table_scroll_width"
      :table_null_width="table_null_width"
      :r_page="r_page"
      :r_limit="r_limit"
      :table_total="table_total"
      @pagination-Change="paginationChange"
      @change-size-limit="changeSizeLimit"
    ></pagingCompont>

    <!-- 复制功能对话框 -->
    <a-modal
      title="确定复制该项？"
      okText="复制"
      cancelText="取消"
      :visible="copy_visible"
      :confirm-loading="copy_confirmLoading"
      @ok="copyOk"
      @cancel="copyCancel"
    >
      <div style="display: flex; align-items: center; font-size: 15px">
        <div style="width: 90px; text-align: right; margin-right: 10px">
          id:
        </div>
        <div>{{ copyModalObj.id }}</div>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          font-size: 15px;
          margin-top: 10px;
        "
      >
        <div style="width: 90px; text-align: right; margin-right: 10px">
          落地页名称:
        </div>
        <div>{{ copyModalObj.title }}</div>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          font-size: 15px;
          margin-top: 10px;
        "
      >
        <div style="width: 90px; text-align: right; margin-right: 10px">
          公众号:
        </div>
        <div>{{ copyModalObj.gzh_name }}</div>
      </div>
    </a-modal>

    <!-- 批量删除 -->
    <a-modal
      v-model="dl_modal"
      title="批量删除"
      okType="danger"
      width="700px"
      okText="删除"
      cancelText="取消"
      @ok="dlOk"
      @cancel="dlCancel"
      :confirmLoading="dl_loading"
    >
      <div style="">
        <div style="margin-bottom: 10px">已选的删除项：</div>
        <div
          style="
            max-height: 360px;
            overflow-y: auto;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            cursor: default;
          "
        >
          <div
            v-for="(item, index) in selectedData"
            :key="index"
            style="
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              margin-right: 15px;
            "
            class=""
          >
            <div style="width: 80px; text-align: right">id：{{ item.id }}</div>
            <span style="margin: 0 5px"> — </span>
            <div style="width: 195px">{{ item.title }}</div>
          </div>
        </div>

        <!-- <div class="">id：4 —— 李永润</div> -->
      </div>
    </a-modal>

    <!-- 批量设置付费 -->
    <a-modal
      v-model="pl_modal"
      title="批量设置付费"
      okType="primary"
      width="700px"
      okText="设置"
      cancelText="取消"
      @ok="plOk"
      @cancel="plCancel"
      :confirmLoading="pl_loading"
    >
      <div style="">
        <div style="display: flex; align-items: center">
          <div style="font-size: 15px; margin-right: 10px">状态：</div>
          <div>
            <a-radio-group
              @change="setFfRadio"
              name="radioGroup"
              default-value="1"
            >
              <a-radio value="1"> 开启 </a-radio>
              <a-radio value="0"> 关闭 </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div style="margin-bottom: 10px; margin-top: 15px">
          已选的设置付费项：
        </div>
        <div
          style="
            max-height: 360px;
            overflow-y: auto;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            cursor: default;
          "
        >
          <div
            v-for="(item, index) in selectedData"
            :key="index"
            style="
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              margin-right: 15px;
            "
            class=""
          >
            <div style="width: 80px; text-align: right">id：{{ item.id }}</div>
            <span style="margin: 0 5px"> — </span>
            <div style="width: 195px">{{ item.title }}</div>
          </div>
        </div>

        <!-- <div class="">id：4 —— 李永润</div> -->
      </div>
    </a-modal>

    <!-- 图片查看 -->
    <a-modal
      v-model="img_visible"
      width="550px"
      title="图片展示"
      @ok="imgOk"
      okText="确认"
      cancelText="取消"
      :footer="null"
    >
      <img
        style="width: 500px; max-height: 600px; object-fit: contain"
        :src="show_modal_img"
        alt=""
      />
    </a-modal>

    <!-- 回传比例相关侧边栏 -->
    <a-drawer
      :title="hc_drawer_title"
      width="700px"
      placement="right"
      :closable="false"
      :visible="hc_visible"
      @close="hcCloseDrawer"
    >
      <div v-if="hc_drawer_title == '添加回传比例任务'" style="padding: 10px">
        <div class="form-cell-box">
          <div class="class-title">落地页名称</div>

          <div style="font-size: 15px">{{ hc_land_title }}</div>
        </div>

        <div class="form-cell-box">
          <div class="class-title">日期范围</div>

          <a-range-picker
            style="width: 300px"
            @change="onChangeDate"
            :allowClear="false"
            :disabledDate="disabledDate"
            :locale="locale"
            :value="[
              this.moment(startTime, dateFormat),
              this.moment(endTime, dateFormat),
            ]"
          />
        </div>

        <div class="form-cell-box">
          <div class="class-title">定时任务</div>

          <div>
            <div
              v-for="(item, index) in hcTimeData"
              :key="index"
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <div
                style="display: flex; align-items: center; margin-right: 20px"
              >
                <div class="hc-drawer-title">时间点</div>

                <a-time-picker
                  :open.sync="item.hc_time_open2"
                  :value="moment(item.hc_time_value, 'HH:mm:ss')"
                  @change="(...defaultArgs) => hcTimeChange(defaultArgs, index)"
                  :getPopupContainer="getsPopupContainer"
                  :allowClear="false"
                >
                  <a-button
                    slot="addon"
                    size="small"
                    type="primary"
                    @click="hcTimeClose(index)"
                  >
                    确认
                  </a-button>
                </a-time-picker>
              </div>

              <div
                style="display: flex; align-items: center; margin-right: 20px"
              >
                <div class="hc-drawer-title">回传比例</div>
                <a-input-number
                  id="inputNumber"
                  v-model="item.hc_number_value"
                  :min="0"
                  :max="100"
                />
              </div>

              <a-button @click="delTimeData(index)" type="danger" size="small"
                >删除</a-button
              >
            </div>
          </div>
        </div>
        <div
          class="form-cell-box"
          style="margin-top: -15px; margin-bottom: 35px"
        >
          <div class="class-title"></div>
          <a-button
            @click="pushHcTimeData"
            type="primary"
            size="small"
            style="margin-right: 10px"
            >添加定时任务</a-button
          >
        </div>

        <div class="form-cell-box">
          <div class="class-title">开启</div>

          <a-switch
            @change="hcDrawerSwitch"
            :checked="hc_switch_checked"
            checked-children="打开"
            un-checked-children="关闭"
          />
        </div>

        <div
          style="
            color: red;
            height: 23px;
            margin-top: 35px;
            margin-bottom: -10px;
            margin-left: 40px;
          "
        >
          {{ hc_form_hint }}
        </div>

        <div class="form-cell-box" style="margin-top: 30px; padding-left: 41px">
          <a-button
            @click="hcRequest"
            :loading="hc_button_loading"
            type="primary"
            style="margin-right: 20px"
            >确认</a-button
          >
          <a-button @click="hcCloseDrawer">取消</a-button>
        </div>
      </div>

      <div v-else-if="hc_drawer_title == '回传比例修改记录'">
        <!-- 表头 -->
        <div
          class="table-th"
          :style="{
            width:
              hcTableData[0].width +
              hcTableData[1].width +
              hcTableData[2].width +
              hcTableData[3].width +
              hcTableData[4].width +
              'px',
          }"
        >
          <div v-for="(item, index) in hcTableData" :key="index">
            <div class="table-th-cell" :style="{ width: item.width + 'px' }">
              {{ item.title }}
            </div>
          </div>
        </div>

        <!-- 表格内容 -->
        <div
          v-for="(item, index) in hcTableShowData"
          :key="index"
          class="table-td"
          :style="{
            width:
              hcTableData[0].width +
              hcTableData[1].width +
              hcTableData[2].width +
              hcTableData[3].width +
              hcTableData[4].width +
              'px',
          }"
        >
          <!-- 落地页ID -->
          <div
            class="table-td-cell"
            :style="{ width: hcTableData[0].width + 'px' }"
          >
            {{ item.link_id }}
          </div>
          <!-- 落地页修改比率 -->
          <div
            class="table-td-cell"
            :style="{ width: hcTableData[1].width + 'px' }"
          >
            {{ item.report_per }}
          </div>
          <!-- 落地页历史比率 -->
          <div
            class="table-td-cell"
            :style="{ width: hcTableData[2].width + 'px' }"
          >
            {{ item.old_report_per }}
          </div>
          <!-- 操作人 -->
          <div
            class="table-td-cell"
            :style="{ width: hcTableData[3].width + 'px' }"
          >
            {{ item.op_name }}
          </div>
          <!-- 操作时间 -->
          <div
            class="table-td-cell"
            :style="{ width: hcTableData[4].width + 'px' }"
          >
            {{ item.created_at }}
          </div>
        </div>
        <div
          v-show="hcTableShowData.length === 0"
          style="text-align: center; margin: 80px auto 50px"
        >
          <a-icon style="font-size: 70px; color: #999" type="file-search" />

          <div style="color: #999; font-size: 16px; margin-top: 20px">
            内容为空
          </div>
        </div>

        <!-- 分页 -->
        <div style="width: 100%; text-align: center; margin: 35px auto">
          <a-pagination
            v-model="hc_page"
            :pageSize="hc_limit"
            :total="hc_total"
            @change="hcPaginationChange"
          />
        </div>
      </div>
    </a-drawer>

    <!-- 新增相关侧边栏 -->
    <a-drawer
      :title="add_drawer_title"
      width="900px"
      placement="right"
      :closable="false"
      :visible="add_visible"
      @close="addCloseDrawer"
    >
      <div class="form-cell-box">
        <div class="class-title" style="font-size: 16px; font-weight: 700">
          选择新增类型<span class="required-hint">*</span>
        </div>

        <a-select
          default-value="2"
          style="width: 360px"
          @change="addTypeChange"
          size="large"
        >
          <a-select-option value="0">
            新增头条/广点通/OPPO/VIVO落地页
          </a-select-option>
          <a-select-option value="1"> 新增百度跳转页 </a-select-option>
          <a-select-option value="2"> 新增360落地页 </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box">
        <div class="class-title">标题<span class="required-hint">*</span></div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div class="form-cell-box">
        <div class="class-title">渠道<span class="required-hint">*</span></div>
        <a-select
          show-search
          style="min-width: 360px"
          placeholder="请选择"
          @change="addChangeA"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
        >
          <a-select-option
            v-for="(item, index) in filterData.channel_id.list"
            :key="index"
            :value="item.key"
          >
            {{ item.value }}
          </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          公众号<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          style="min-width: 360px"
          placeholder="请选择"
          notFoundContent="请先选择: 渠道 ↑"
          @change="addChangeB"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
        >
          <a-select-option
            v-for="(value, key) in gzhSelectList"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          公众号二维码<span class="required-hint">*</span>
        </div>
        <div>当前公众号没有永久二维码</div>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          跳转方式<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          style="min-width: 360px"
          placeholder="请选择"
          @change="addChangeC"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          defaultValue="360"
        >
          <a-select-option value="360"> 扫码关注（仅360） </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          回传方式<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          style="min-width: 360px"
          placeholder="请选择"
          @change="addChangeG"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          defaultValue="0"
        >
          <a-select-option value="0"> 页面底部JS回传 </a-select-option>
          <a-select-option value="1"> 关注API回传 </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          360账号ID<span class="required-hint">*</span>
        </div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          360转化代码ID<span class="required-hint">*</span>
        </div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          API_JZQS<span class="required-hint">*</span>
        </div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          API_KEY<span class="required-hint">*</span>
        </div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          API_SECRET<span class="required-hint">*</span>
        </div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          媒体Id<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          style="min-width: 360px"
          placeholder="请选择"
          @change="addChangeD"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
        >
          <a-select-option
            v-for="(value, key) in mediaSelectList"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          360模板Id<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          style="min-width: 360px"
          placeholder="请选择"
          @change="addChangeE"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          notFoundContent="请先选择: 媒体Id ↑"
          allowClear
        >
          <a-select-option
            v-for="(value, key) in sixMubanList"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          投放域名地址<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          style="min-width: 360px"
          placeholder="请选择"
          @change="addChangeF"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
        >
          <a-select-option
            v-for="(value, key) in domainList"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          审核公司<span class="required-hint">*</span>
        </div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          网址名称<span class="required-hint">*</span>
        </div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          联系电话<span class="required-hint">*</span>
        </div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          公司地址<span class="required-hint">*</span>
        </div>

        <a-input v-model="aaa" placeholder="请输入" style="width: 360px" />
      </div>

      <div style="color: red; height: 23px; width: 100%">
        {{ add_form_hint }}
      </div>

      <div class="form-cell-box" style="margin-top: 30px; padding-left: 25px">
        <a-button
          @click="addRequest"
          :loading="add_button_loading"
          type="primary"
          style="margin-right: 20px"
          >确认</a-button
        >
        <a-button @click="addCloseDrawer">取消</a-button>
      </div>
    </a-drawer>

    <!-- 编辑单项的弹窗 -->
    <a-modal
      :title="`编辑`"
      :visible="edit_visible"
      :confirm-loading="edit_confirmLoading"
      cancelText="取消"
      okText="确认"
      width="500px"
      @ok="editModalOk"
      @cancel="editModalCancel"
    >
      <div class="form-cell-box">
        <div class="class-title">回传比例</div>

        <a-input
          v-model="e_report_per"
          style="width: 240px"
          placeholder="请输入"
        />
      </div>
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import {
  landPageList,
  landPagePlatform,
  landPageJumpType,
  putDataMenu,
  editActivePayStatus,
  landPageLinkDelete,
  landPageLinkCopy,
  landPageSingleEdit,
  setReportPerPlan,
  logReportPer,
  landPageChannelGzh,
  getPutDomain,
  landPageSixMedia,
  landSixTemplate,
} from "@/request/api";
import moreSelect from "@/components/selectCompont/moreSelect.vue";
export default {
  name: "landPage_",
  components: {
    moreSelect,
  },
  data() {
    this.dateFormat = "YYYY-MM-DD";
    return {
      locale,
      moment,
      startTime: "2022-06-12",
      endTime: "2022-06-25",

      // 筛选条件部分
      filterData: {
        op_id: {
          // 投手
          list: [{}],
        },
        channel_id: {
          // 书城渠道
          list: [{}],
        },
        gzh_id: {
          // 公众号
          list: [{}],
        },
      }, // 筛选条件数组
      PlatformData: {}, // 落地页推广平台数据
      JumpTypeData: {}, // 落地页跳转方式数据

      r_id: "", // 请求用的id
      r_title: "", // 标题
      r_op_id: undefined, // 投手
      r_channel_id: undefined, // 渠道
      r_gzh_id: undefined, // 公众号
      r_jump_type: undefined, // 跳转方式
      r_open_put: undefined, // 是否打开投放
      r_put_platform: undefined, // 推广平台，投放平台

      r_page: 1, // 页数
      r_limit: 20, // 每页多少条
      table_total: 0, // 总数

      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        { title: "ID", width: 70, type: "id" }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
        { title: "落地页名称", width: 130, type: "title" },
        { title: "落地页链接", width: 280, type: "put_url" },
        { title: "公众号", width: 100, type: "gzh_name" },
        { title: "顶部图片", width: 160, type: "top_image" },
        { title: "跳转方式", width: 140, type: "jump_type" },
        { title: "关联小程序", width: 210, type: "gzh_app_rel" },
        { title: "投放平台", width: 100, type: "put_platform" },
        { title: "是否打开投放", width: 120, type: "open_put" },
        { title: "回传比例", width: 100, type: "report_per" },
        { title: "操作", width: 160, type: "cz" },
        { title: "创建人", width: 120, type: "op_name" },
        { title: "创建时间", width: 160, type: "created_at" },
        { title: "跳转落地页", width: 120, type: "redirect_to" },
        { title: "备注", width: 160, type: "memo" },
      ],
      tableShowData: [],
      search_button_loading: false,
      table_scroll_width: 1600,
      body_width: 1600,
      table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
      table_body_height: 2400,

      // 多选
      indeterminate: false,
      checkAll: false,
      selected_number: 0, // 已选数量
      selectedData: [], // 选中的数据

      // 批量删除弹窗
      dl_modal: false,
      dl_loading: false,
      // 批量设置付费
      pl_modal: false,
      pl_loading: false,
      r_is_supply_active_pay: "1", // 批量设置付费的状态。1是开启。0是关闭
      // 复制
      copy_visible: false,
      copy_confirmLoading: false,
      copyModalObj: {}, // 点击的表格行内容
      // 图片展示
      img_visible: false,
      show_modal_img: "", // 图片链接
      // 回传比例侧边栏
      hc_link_id: "", // 回传id
      hc_drawer_title: "", // 标题
      hc_visible: false,
      hc_button_loading: false, // 回传侧边栏确认按钮的加载状态
      hc_land_title: "", // 回传落地页名称
      hc_time_open2: false,
      hc_time_value: "00:00:00", // 回传比例侧边栏的时间选择框
      hc_number_value: 100, // 回传比例
      hc_switch_checked: false, // 回传比例侧边栏开关按钮
      hcTimeData: [
        {
          hc_time_value: "00:00:00",
          hc_number_value: 100,
          hc_time_open2: false,
        },
      ],
      hc_form_hint: "", // 侧边栏新增表单的验证提示
      hcTableData: [
        { title: "落地页ID", width: 90, type: "id" }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
        { title: "落地页修改比率", width: 130, type: "title" },
        { title: "落地页历史比率", width: 130, type: "put_url" },
        { title: "操作人", width: 100, type: "gzh_name" },
        { title: "操作时间", width: 160, type: "top_image" },
      ],
      hcTableShowData: [],
      hc_page: 1,
      hc_limit: 10,
      hc_total: 0,

      // 新增侧边栏
      add_visible: false,
      aaa: "",
      add_type: "0", // 新增类型。0为新增头条/广点通/OPPO/VIVO落地页。1为新增百度跳转页。2为新增360落地页
      add_drawer_title: "新增360落地页",
      add_form_hint: "", // 新增侧边栏的提示
      add_button_loading: false,
      gzhSelectList: {},
      mediaSelectList: {},
      sixMubanList: {},
      domainList: {},

      role_control: [], // 用户权限控制

      // 单个编辑弹窗
      edit_visible: false, // 编辑弹窗的显示
      edit_modal_title: "", // 编辑弹窗的标题
      edit_confirmLoading: false,
      e_id: "", // 修改id
      e_report_per: "", // 修改回传比例

      ld_change_tilte: "", // 更改前的落地页名称
    };
  },
  mounted() {
    let that = this;

    that.search_button_loading = true;

    that.body_width = document.body.clientWidth;

    let nn = 0;
    that.rableTitle.forEach((res, index) => {
      nn = nn + res.width;
    });
    that.table_scroll_width = nn + 30 + 60; // 30是右边的边距，60是选择框
    if (that.table_scroll_width >= that.body_width) {
      that.table_null_width = that.body_width - 60;
    } else {
      that.table_null_width = that.table_scroll_width - 60;
    }

    // 获取当前日期
    let date2 = new Date();
    let month2;
    if (date2.getMonth() + 1 < 10) {
      month2 = "0" + (date2.getMonth() + 1);
    } else {
      month2 = date2.getMonth() + 1;
    }
    let day2;
    if (date2.getDate() < 10) {
      day2 = "0" + date2.getDate();
    } else {
      day2 = date2.getDate();
    }
    // console.log("date2.getDate();",date2.getDate())
    that.startTime = date2.getFullYear() + "-" + month2 + "-" + day2;

    // 获取7天后日期
    let date1 = new Date(new Date().getTime() + 604800000);
    let month1;
    if (date1.getMonth() + 1 < 10) {
      month1 = "0" + (date1.getMonth() + 1);
    } else {
      month1 = date1.getMonth() + 1;
    }
    let day1;
    if (date1.getDate() < 10) {
      day1 = "0" + date1.getDate();
    } else {
      day1 = date1.getDate();
    }
    that.endTime = date1.getFullYear() + "-" + month1 + "-" + day1;

    // 获取角色权限
    that.role_control = JSON.parse(localStorage.getItem("role_limits"));

    putDataMenu().then((res) => {
      console.log("筛选条件", res.data.data);
      that.filterData = res.data.data.filter;

      that.searchButton();

      that.$refs.getGzhSelect.getSelectData(that.filterData.gzh_id.list || []);
    });

    landPagePlatform().then((res) => {
      console.log("落地页推广平台", res.data.data);
      that.PlatformData = res.data.data.list;
    });

    landPageJumpType().then((res) => {
      console.log("落地页跳转方式", res.data.data);
      that.JumpTypeData = res.data.data.list;
    });
  },
  updated() {
    //
    // console.log("数据更新");
  },
  methods: {
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeA(e) {
      // 投手
      console.log(e);
      this.r_op_id = e;
    },
    handleChangeF(e) {
      // 书城/渠道
      console.log(e);
      this.r_channel_id = e;
    },
    handleChangeG(e) {
      // 公众号
      console.log(e);
      this.r_gzh_id = e;
    },
    handleChangeH(e) {
      // 跳转方式
      console.log(e);
      this.r_jump_type = e;
    },
    handleChangeI(e) {
      // 投放平台
      console.log(e);
      this.r_put_platform = e;
    },
    handleChangeJ(e) {
      // 是否打开投放
      console.log(e);
      this.r_open_put = e;
    },

    // 搜索
    searchButton(type) {
      let that = this;
      that.search_button_loading = true;

      if (type != "分页") {
        that.selectedData = []; // 已选内容清空
      }
      if (type == "button") {
        that.r_page = 1;
      }

      let r_data = {
        page: that.r_page, // 页数
        limit: that.r_limit, // 每页多少条
        id: that.r_id,
        title: that.r_title,
        channel_id: that.r_channel_id, // 书城/渠道
        gzh_id: that.r_gzh_id, // 公众号
        jump_type: that.r_jump_type, // 跳转方式
        put_platform: that.r_put_platform, // 投放平台
        open_put: that.r_open_put, // 是否打开投放
      };
      // 超级管理、投放管理可以有 投手
      if (that.role_control.includes(1) || that.role_control.includes(3)) {
        console.log("权限检查----------");
        r_data.op_id = that.r_op_id; // 投手
      }
      landPageList(r_data).then((res) => {
        console.log("搜索结果", res.data.data);
        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("搜索成功");
          that.table_total = res.data.data.total;

          let data = res.data.data.data;
          // 这里这么做是为了把height这个属性变成响应式的。不然下面给height添加每行的高度，页面不会响应。当然也可以用this.$set
          data.forEach((res, index) => {
            res.height = 90;
            res.checked = false;
            res.open_put_loading = false; // 是否打开投放loading

            res.title_input_control = false; // 落地页名称修改的input控制

            let aaa = [];
            let bbb = [];
            res.gzh_app_rel.forEach((res_z, index_z) => {
              if (res_z.is_using == 1) {
                // 表示小程序可用状态
                aaa.push(res_z);
              } else {
                // 不可用状态
                bbb.push(res_z);
              }
            });

            res.show_gzh_app = aaa.concat(bbb);
          });
          console.log("data", data);

          if (that.selectedData.length > 0) {
            let ccc = true;
            let iii = 0; // 用于判断是否全选
            data.forEach((res) => {
              that.selectedData.forEach((res_r) => {
                if (res.id === res_r.id) {
                  res.checked = true;
                  ccc = false;
                  iii = iii + 1;
                }
              });
            });
            console.log("iii", iii);
            if (iii === that.r_limit) {
              // 全选
              that.indeterminate = false;
              that.checkAll = true;
            } else {
              if (ccc) {
                that.checkAll = false;
                that.indeterminate = false;
              } else {
                that.checkAll = false;
                that.indeterminate = true;
              }
            }
          } else {
            console.log("that.checkAll", that.checkAll);
            that.checkAll = false;
            that.indeterminate = false;
          }

          that.tableShowData = data; // 整个数组替换，里面属性会变成响应式

          setTimeout((res) => {
            // 必须要等渲染完了，才能去获取
            // console.log("that.$refs.tdHeight",that.$refs.tdHeight)
            // that.table_body_height = that.$refs.tdHeight.offsetHeight
            let ref_data = that.$refs.tdHeight;
            that.tableShowData.forEach((res, index) => {
              res.height = ref_data[index].offsetHeight;
              // console.log(res.height)
            });
            // ref_data.forEach((res,index)=>{
            // 	console.log(index,res.offsetHeight)

            // })
            that.search_button_loading = false;
            // console.log("that.tableShowData",that.tableShowData)
          }, 200); // 设置200毫秒以上是为了获取数据更准确，如果设置100毫秒数据会不准
        } else {
          if (res.data.code === 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`其他错误：${res.data.msg}`);
          }
        }

        // 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
        document
          .querySelector("body")
          .setAttribute("style", "overflow-x: visible;");
        setTimeout(() => {
          document
            .querySelector("body")
            .setAttribute("style", "overflow-x: visible;");
        }, 300);
      });
    },

    // 分页的页数变化
    paginationChange(e) {
      console.log(e);
      this.r_page = e;
      this.searchButton("分页");
    },
    changeSizeLimit(e) {
      // console.log('每页多少条',e)
      this.r_limit = e;
      this.searchButton("button");
    },

    // 多选测试
    onChangeCheckbox(checkedList, index) {
      let that = this;
      if (that.tableShowData[index].checked) {
        // 为选中状态，然后要改为未选中状态
        that.tableShowData[index].checked = false;

        let iii;
        console.log(
          "that.tableShowData[index].id",
          that.tableShowData[index].id
        );
        that.selectedData.forEach((res, index_z) => {
          if (res.id == that.tableShowData[index].id) {
            iii = index_z;
          }
        });
        that.selectedData.splice(iii, 1);
        console.log("iii", iii);
      } else {
        // 未选中状态改为选中状态
        that.tableShowData[index].checked = true;
        if (that.selectedData.length === 0) {
          that.selectedData.push(that.tableShowData[index]);
        } else {
          // 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
          let ddd = true;
          for (let i = 0; i < that.selectedData.length; i++) {
            if (that.selectedData[i].id === that.tableShowData[index].id) {
              ddd = false;
              break;
            }
          }
          if (ddd) {
            that.selectedData.push(that.tableShowData[index]);
          }
        }
      }
      // that.tableShowData[index].checked = !that.tableShowData[index].checked
      console.log("that.selectedData", that.selectedData);
      let ccc = true;
      let iii = false;
      let nnn = that.selectedData.length || 0;
      console.log("that.selectedData.length", that.selectedData.length);
      that.tableShowData.forEach((res) => {
        if (res.checked) {
          iii = true;
          // nnn = nnn + 1
        }
        if (!res.checked) {
          ccc = false;
        }
      });
      // console.log("nnn",nnn)
      if (ccc) {
        that.indeterminate = false;
      } else {
        that.indeterminate = iii;
      }
      that.checkAll = ccc;
      that.selected_number = nnn;
    },
    // 全选
    onCheckAllChange(e) {
      let that = this;
      if (that.checkAll) {
        that.tableShowData.forEach((res) => {
          res.checked = false;
        });
        that.checkAll = false;
        // that.selected_number = 0

        that.selectedData = []; // 取消全选的时候，全部清除
      } else {
        that.tableShowData.forEach((res) => {
          res.checked = true;
          // 有重复的就不要传了
          let ddd = true;
          that.selectedData.forEach((res_r) => {
            if (res_r.id === res.id) {
              ddd = false;
              console.log("l", ddd);
            }
          });

          if (ddd) {
            console.log("w", ddd);
            that.selectedData.push(res);
          }
        });
        // that.selected_number = that.tableShowData.length
        that.indeterminate = false;
        that.checkAll = true;
      }
    },
    // 复制投放地址
    thDzCopy(item) {
      let that = this;
      let url = item.put_url;
      if (item.put_platform == "快手") {
        url = `${item.put_url}?ip=__IP__&ua=__UA__&account_id=__ACCOUNTID__&aid=__AID__&did=__DID__&cid=__CID__&clk_time=__TS__&os=__OS__&model=__MODEL__&imei_md5=__IMEI2__&idfa=__IDFA__&android_id_md5=__ANDROIDID2__&ipv6=__IPV6__&callback=__CALLBACK__`;
      }
      this.$copyText(url)
        .then((res) => {
          that.$message.success("复制成功");
        })
        .catch((err) => {
          that.$message.error("复制失败");
        });
    },
    // 复制联调地址
    thLtCopy(e) {
      let that = this;
      if (e.put_platform === "头条") {
        let url = e.put_url + "?liantiao=1";
        this.$copyText(url)
          .then((res) => {
            that.$message.success("复制成功");
          })
          .catch((err) => {
            that.$message.error("复制失败");
          });
      } else if (e.put_platform === "百度") {
        let url = e.put_url + "?bd_vid={bd_vid}&liantiao=1";
        this.$copyText(url)
          .then((res) => {
            that.$message.success("复制成功");
          })
          .catch((err) => {
            that.$message.error("复制失败");
          });
      }
    },
    // 表格内的复制按钮
    thCopy(e) {
      this.copy_visible = true;
      this.copyModalObj = e;
    },
    // 复制弹窗确认按钮
    copyOk() {
      let that = this;
      that.copy_confirmLoading = true;
      landPageLinkCopy({
        id: this.copyModalObj.id,
      }).then((res) => {
        console.log("复制结果", res);
        that.copy_confirmLoading = false;
        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("复制成功");
          that.copyCancel();
          that.searchButton();
        } else {
          that.$message.error("复制失败");
        }
      });
    },
    copyCancel() {
      if (this.copy_confirmLoading) {
        return;
      }
      this.copy_visible = false;
    },
    // 批量删除按钮
    plDelButton() {
      if (this.selectedData.length > 0) {
        this.dl_modal = true;
      } else {
        this.$message.warning("还没有选择内容");
      }
    },
    delReq(d_data) {
      let that = this;
      that.dl_loading = true;

      // 批量删除请求
      landPageLinkDelete({
        ids: d_data,
      }).then((res) => {
        that.dl_loading = false;
        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("删除成功");

          that.dlCancel();
          that.searchButton();
        } else {
          that.$message.error("删除失败");
        }
      });
    },
    // 批量删除确认
    dlOk() {
      let that = this;

      let d_data = [];
      that.selectedData.forEach((res) => {
        d_data.push(res.id);
      });
      console.log("d_data", d_data);
      that.delReq(d_data);
    },
    // 表格内删除按钮
    thDel(e) {
      let that = this;
      console.log(e);
      this.$confirm({
        title: "确定要删除吗?",
        content: `落地页名称：${e.title}`,
        okText: "删除",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          let d_data = [];
          d_data.push(e.id);
          that.delReq(d_data);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    // 删除弹窗取消
    dlCancel() {
      if (this.dl_loading) {
        return;
      }

      this.dl_modal = false;
    },
    // 批量设置付费
    plSetButton() {
      if (this.selectedData.length > 0) {
        this.pl_modal = true;
      } else {
        this.$message.warning("还没有选择内容");
      }
    },
    plOk() {
      let that = this;
      that.dl_loading = true;
      let d_data = [];
      that.selectedData.forEach((res) => {
        d_data.push(res.id);
      });
      console.log("d_data", d_data);
      // 批量设置付费请求
      editActivePayStatus({
        ids: d_data,
        is_supply_active_pay: that.r_is_supply_active_pay,
      }).then((res) => {
        that.pl_loading = false;
        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("设置成功");
          that.plCancel();
          that.searchButton();
        } else {
          that.$message.error("设置失败");
        }
      });
    },
    setFfRadio(e) {
      // 单选。选择开启或关闭
      console.log(e.target.value);
      this.r_is_supply_active_pay = e.target.value;
    },
    plCancel() {
      if (this.pl_loading) {
        return;
      }

      this.pl_modal = false;
    },

    // 是否打开投放
    openPut(e, index) {
      let that = this;
      console.log(e, index);
      this.tableShowData[index].open_put_loading = true;
      let o_p;
      if (e) {
        o_p = 1; // 打开
      } else {
        o_p = 0; // 关闭
      }
      landPageSingleEdit({
        id: that.tableShowData[index].id,
        open_put: o_p,
      }).then((res) => {
        console.log("是否打开投放", res);
        that.tableShowData[index].open_put_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("操作成功");
          that.tableShowData[index].open_put = e;
        } else {
          that.$message.error("操作失败");
        }

        // 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
        document
          .querySelector("body")
          .setAttribute("style", "overflow-x: visible;");
        setTimeout(() => {
          document
            .querySelector("body")
            .setAttribute("style", "overflow-x: visible;");
        }, 300);
      });
    },
    // 图片打开查看
    tdShowImg(e) {
      let that = this;
      console.log(e);
      this.show_modal_img = e.top_image;
      this.img_visible = true;
    },
    imgOk() {
      this.img_visible = false;
    },

    // 回传比例
    returnRatio(e, type) {
      let that = this;
      console.log(e);
      this.hc_land_title = e.title;
      this.hc_link_id = e.id;
      if (type == 1) {
        // 回传比例修改记录
        that.hc_drawer_title = "回传比例修改记录";
        that.search_button_loading = true;
        logReportPer({
          link_id: e.id,
        }).then((res) => {
          that.search_button_loading = false;
          console.log("回传比例修改记录", res);
          that.hcTableShowData = res.data.data.data;
          that.hc_total = res.data.data.total;
          that.hc_visible = true;
        });
      } else if (type == 2) {
        // 添加回传比例任务
        this.hc_drawer_title = "添加回传比例任务";
        this.hc_visible = true;
      }
    },
    // 回传侧边栏表格分页
    hcPaginationChange(e) {
      let that = this;
      this.hc_page = e;
      logReportPer({
        link_id: e.id,
        page: that.hc_page,
        hc_limit: that.hc_limit,
      }).then((res) => {
        console.log("回传比例修改记录", res);
        that.hcTableShowData = res.data.data.data;
        that.hc_total = res.data.data.total;
      });
    },
    // 回传比例侧边栏关闭
    hcCloseDrawer() {
      if (this.hc_button_loading) {
        return;
      }

      this.hc_visible = false;
      this.hc_form_hint = "";
      this.hcTimeData = [
        {
          hc_time_value: "00:00:00",
          hc_number_value: 100,
          hc_time_open2: false,
        },
      ];
      this.hc_switch_checked = false;

      this.hc_page = 1;

      document
        .querySelector("body")
        .setAttribute("style", "overflow-x: visible;");
      setTimeout(() => {
        document
          .querySelector("body")
          .setAttribute("style", "overflow-x: visible;");
      }, 300);
    },
    // 日期选择
    onChangeDate(date, dateString) {
      console.log(date, dateString);
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },
    // 时间选择关闭
    hcTimeClose(index) {
      this.hcTimeData[index].hc_time_open2 = false;
    },
    disabledDate(current) {
      return current && current < moment().subtract(1, "days");
    },
    // 回传比例侧边栏 开关按钮
    hcDrawerSwitch(e) {
      console.log(e);
      this.hc_switch_checked = e;
    },
    // 回传比例时间选择
    hcTimeChange(ee, index) {
      // console.log(moment(hc_time_value, 'HH:mm:ss'));
      console.log(ee, index);
      this.hcTimeData[index].hc_time_value = ee[1];
    },
    // 添加定时任务
    pushHcTimeData() {
      this.hcTimeData.push({
        hc_time_value: "00:00:00",
        hc_number_value: 100,
        hc_time_open2: false,
      });
    },
    // 删除定时任务
    delTimeData(index) {
      if (this.hcTimeData.length > 1) {
        this.hcTimeData.splice(index, 1);
      }
    },
    // 回传比例确认按钮
    hcRequest() {
      let that = this;

      that.hc_button_loading = true;

      console.log(this.hcTimeData);
      // let tt = that.hc_time_value.split(':')
      // let r_tt = Number(tt[0])*60*60 + Number(tt[1])*60 + Number(tt[2])
      console.log("this.hcTimeData", this.hcTimeData);
      let r_time_obj = {};
      this.hcTimeData.forEach((res) => {
        let tt = res.hc_time_value.split(":");
        let r_tt = Number(tt[0]) * 60 * 60 + Number(tt[1]) * 60 + Number(tt[2]);
        r_time_obj[r_tt] = res.hc_number_value;
      });
      console.log("r_time_obj", r_time_obj);

      let r_status;
      if (that.hc_switch_checked) {
        // 开启
        r_status = 1;
      } else {
        r_status = 0; // 关闭
      }

      let r_data = {
        link_id: that.hc_link_id, // 落地页id
        start_time: that.startTime.replace(/-/g, ""), // 任务开始时间
        end_time: that.endTime.replace(/-/g, ""), // 任务结束时间
        status: r_status, // 状态0=关闭，1=开启
        time: r_time_obj,
      };
      setReportPerPlan(r_data).then((res) => {
        console.log("回传比例确认按钮", res);
        that.hc_button_loading = false;
        if (res.data.code == 0) {
          that.hcCloseDrawer();
          that.$message.success("操作成功");
          that.searchButton();
        } else {
          that.hc_form_hint = res.data.msg;
        }
      });
    },

    // 新增部分开始------
    // 显示新增侧边栏
    addShowDrawer(e) {
      let that = this;
      // // 360媒体id下拉列表
      // landPageSixMedia().then(res=>{
      // 	console.log("360媒体id下拉列表",res.data);
      // 	that.mediaSelectList = res.data.data.list
      // })

      // // 获取转换域名
      // getPutDomain().then(res=>{
      // 	console.log("获取转换域名",res.data);
      // 	that.domainList = res.data.data.data
      // })

      // this.add_visible = true
      let jump_url = "";
      if (e == 1) {
        // 头条/广点通/OPPO/VIVO/百度落地页新增
        // that.$router.push({path: '/landPageAdd'})
        jump_url = "/landPageAdd";
      } else if (e == 2) {
        // 360落地页新增
        // that.$router.push({path: '/landAdd360'})
        jump_url = "/landAdd360";
      }
      const { href } = this.$router.resolve(jump_url);
      window.open(href, "_blank");
    },
    // 选择新增类型
    addTypeChange(e) {
      console.log(e);
      this.add_type = e;
      if (e == "0") {
        this.add_drawer_title = "新增头条/广点通/OPPO/VIVO落地页";
      } else if (e == "1") {
        this.add_drawer_title = "新增百度跳转页";
      } else if (e == "2") {
        this.add_drawer_title = "新增360落地页";
      }
    },
    // 新增侧边栏-选择渠道
    addChangeA(e) {
      let that = this;
      console.log(e);
      // 渠道公众号
      landPageChannelGzh({ channel_id: e }).then((res) => {
        console.log("渠道公众号", res.data.data);
        that.gzhSelectList = res.data.data.list;
      });
    },
    // 新增侧边栏-选择公众号
    addChangeB(e) {},
    // 新增侧边栏-跳转方式
    addChangeC(e) {},
    // 回传方式
    addChangeG(e) {},
    // 新增侧边栏-媒体Id
    addChangeD(e) {
      let that = this;
      console.log(e);
      landSixTemplate({ media_id: e }).then((res) => {
        console.log("360媒体id对应落地页模板", res);
        that.sixMubanList = res.data.data.list;
      });
    },
    // 新增侧边栏-360模板Id
    addChangeE(e) {},
    // 新增侧边栏-投放域名地址
    addChangeF(e) {},

    // 新增侧边栏确认按钮
    addRequest() {},
    // 新增侧边栏取消按钮
    addCloseDrawer() {
      this.add_visible = false;
    },

    // 编辑
    editLand(e) {
      console.log(e);
      let jump_url = "";
      if (e.put_platform == "360") {
        jump_url = "/landAdd360";
        // this.$router.push({ path:'/landAdd360',query:{link_id: e.id}})
      } else {
        jump_url = "/landPageAdd";
        // this.$router.push({ path:'/landPageAdd',query:{link_id: e.id}})
      }
      const { href } = this.$router.resolve({
        path: jump_url,
        query: { link_id: e.id },
      });
      window.open(href, "_blank");
    },

    // 批量操作
    handleButtonClick(e) {
      // console.log('click left button', e);
    },
    // 批量操作按钮点击
    handleMenuClick(e) {
      console.log("click", e);

      let that = this;
      if (e.key == "1") {
        // 批量设置巨量付费2
        that.plSetButton();
      } else if (e.key == "2") {
        // 批量删除
        that.plDelButton();
      }
    },

    // 单项修改
    editTd(e, type) {
      console.log(e);
      if (type == 1) {
        // 修改回传比例
        this.e_id = e.id;
        this.e_report_per = e.report_per;
        this.edit_visible = true;
      }
    },
    editModalOk() {
      let that = this;

      if (!that.e_report_per) {
        this.$message.warning("内容不能为空");
      } else {
        that.edit_confirmLoading = true;
        landPageSingleEdit({
          id: that.e_id,
          report_per: that.e_report_per,
        }).then((res) => {
          console.log("编辑", res);
          that.confirmLoading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.editModalCancel();
            that.$message.success("编辑成功");
            that.searchButton();
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            }
            that.$message.error(res.data.msg || "请求失败");
          }
        });
      }
    },
    editModalCancel() {
      let that = this;
      this.e_admin_id = undefined;
      this.edit_visible = false;
    },

    // 点击落地页名字
    ldTitleClick(item) {
      // console.log('点击落地页名字',item);
      item.title_input_control = !item.title_input_control;
      this.ld_change_tilte = item.title;
      this.$nextTick(() => {
        // console.log(this.$refs.title_input);
        this.$refs.title_input[0].focus();
      });
    },
    // 落地页名称输入框失去焦点
    LdTitleChange(e, item, index) {
      let that = this;
      // console.log("失去焦点",e.target.value);
      item.title_input_control = false;
      // console.log("失去焦点item",item);
      if (e.target.value != this.ld_change_tilte) {
        // 不相等说明有改动
        landPageSingleEdit({
          id: item.id,
          title: e.target.value,
        }).then((res) => {
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.$message.success("修改落地页名称成功");
            that.tableShowData[index].title = e.target.value;
          } else {
            that.$message.error(res.data.msg || "修改落地页名称失败");
          }
        });
      }
    },

    // 点击关联的小程序进行跳转
    jumpHandle(e) {
      // console.log(e);
      if (e.jump_type == 1) {
        window.open(e.jump_url);
      }
    },
  },
};
</script>

<style scoped>
.button-right {
  margin-right: 20px;
}

.td-cz {
  margin-right: 7px;
  margin-bottom: 3px;
  cursor: pointer;
  font-size: 13px;
}

.hc-drawer-title {
  margin-right: 10px;
}

.table-td-cell {
  font-size: 13px;
}

/* 表格内的小程序 */
.xcx-cell,
.xcx-cell-false {
  padding: 1px 7px;
  margin-bottom: 5px;
  margin-right: 7px;
  text-align: center;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
}
.xcx-cell {
  color: #fff;
  background-color: #62a8ea;
}
.xcx-cell-false {
  color: #fff;
  background-color: #999;
}

/* 必填提示 */
.required-hint {
  color: red;
  position: absolute;
  right: -8px;
}
</style>
